import {makeAutoObservable} from "mobx";
import { AboutUsEntity } from "../entity/about-us-entity";

export class AboutUsStore {
    public username:string = "";
    public dataSource: AboutUsEntity[] = [];
    public isSubmit:boolean = false;

    constructor() {
        makeAutoObservable(this, { username: false });
    }

    public setUserName(name: string) {
        this.username = name;
    }

    public seIsSubmit(isSubmit: boolean) {
        this.isSubmit = isSubmit;
    }

    public setDataSource(list: AboutUsEntity[]){
        this.dataSource = list;
    }

    public clear = () => {
        this.username = "";
        this.dataSource = [];
    }
}